module.exports = __webpack_public_path__ + "static/media/f27ru.49088e82.pdf";